export default class WaterRegulations {
  static async getData() {
    return new Promise((resolve, reject) => {
      return fetch(`/water_regulations`, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async readCsv(data) {
    return new Promise((resolve, reject) => {
      return fetch(`/water_regulations/read_csv`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: data
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}
